import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: ""
}

import Footer from './components/structure/Footer.vue';
import Navbar from './components/structure/Navbar.vue';
import Container from './components/content/Container.vue';
import { injectStrict } from './plugins/vueServiceContainerPlugin';
import { CatalogAdapterInterface } from './adapters/catalogAdapterInterface';
import { OutageAdapterInterface } from './adapters/outageAdapterInterface';
import store from './store';
import { BrandServiceInterface } from './services/brand/brandServiceInterface';
import router from './router';
import Account from './components/Account.vue';
import { AuthenticationServiceInterface } from './services/authentication/authenticationServiceInterface';
import { Brand } from './services/integration/enums';
import { useRoute } from 'vue-router';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const catalogAdapter = injectStrict<CatalogAdapterInterface>('CatalogAdapterInterface');
const outageAdapter = injectStrict<OutageAdapterInterface>('OutageAdapterInterface');
const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');
const authenticationService = injectStrict<AuthenticationServiceInterface>('AuthenticationServiceInterface');

// Data.
const footerLinks = [
  { name: 'Privacy', href: '/privacy-policy' },
  { name: 'Legal', href: '/legal' },
  { name: 'Outages', href: '/outage' }
];

let headerLinks = [
  { name: 'Features', href: '/#features' },
  { name: 'Plans', href: '/#plans' },
  { name: 'Contact', href: '/#contact' }
];

if (brandService.getName() === Brand.JAM) {
  headerLinks = [];
}

// Events
const unitiRedirect = async () => {
  router.push('/uniti');
};

if (brandService.getName() === Brand.JAM) {
  unitiRedirect();
}

const getSalesPerson = async () => {
  const validSales = ['joshua.james@unitiinternet.com', 'cason.chong@unitiinternet.com', 'jaben.heyworth@unitiinternet.com', 'abee.sharma@unitiinternet.com'];
  if (route.query.salesPerson && validSales.includes(route.query.salesPerson.toString())) {
    store.commit('setSalesPerson', route.query.salesPerson.toString());
  }
};

onMounted(async () => {
  // get sales person
  await router.isReady();
  await getSalesPerson();
  store.commit('setPaymentAttempt', 0);
});

const ctaClicked = () => {
  // When the CTA in the navbar is clicked, focus
  // the main address element if it exists.
  const el = document.getElementById('primary-address-search');
  if (el) {
    el.focus();
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    });
  } else {
    store.commit('setServiceQualification', null);
    router.push('/');
  }
};

// Get catalog for the rest of the site.
const getCatalog = async () => {
  const catalog = await catalogAdapter.getCatalog(brandService.getName());
  store.commit('setCatalog', catalog);
};
getCatalog();

// Initialise use account.
const getAccount = async () => {
  const account = await authenticationService.getAccount();
  store.commit('setAccount', account);
};
getAccount();

const getOutages = async () => {
  const outages = await outageAdapter.fetchOutages();
  store.commit('setOutages', outages);
};
getOutages();

// Set the page title and favicon.
document.title = brandService.getTitle();
var link = document.createElement('link');
link.id = 'favicon';
link.rel = 'shortcut icon';
link.href = brandService.getFavicon();
document.head.appendChild(link);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Account),
    _createVNode(Container, { class: "bg-white" }, {
      default: _withCtx(() => [
        _createElementVNode("header", null, [
          _createVNode(Navbar, {
            onCtaClicked: ctaClicked,
            links: _unref(headerLinks),
            portal: _unref(brandService).getPortalUrl()
          }, null, 8, ["links", "portal"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_router_view),
    (_unref(brandService).getName() !== _unref(Brand).HIS)
      ? (_openBlock(), _createBlock(Container, {
          key: 0,
          class: "bg-white"
        }, {
          default: _withCtx(() => [
            _createVNode(Footer, {
              class: "",
              main: footerLinks
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(brandService).getName() === _unref(Brand).HIS)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(Footer, {
            class: "",
            main: footerLinks
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})